import difference from 'lodash/difference';
import pullAll from 'lodash/pullAll';

// src/helpers/array.ts
var getLeftJoin = (a, b) => {
  const result = a;
  pullAll(
    result,
    // 1,2,3
    difference(a, b)
    //3
  );
  return result;
};
var trimArrayToMaxLength = (array, maxLength) => array.length <= maxLength ? array : array.slice(0, maxLength);

export { getLeftJoin, trimArrayToMaxLength };
